import {AfterViewInit, Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/dashboard/dashboard.component.ts